import { styled } from 'linaria/react';

export const StyledWrap = styled.div`
  margin-top: -24px;
`;
